export default __webpack_public_path__ + "static/assets/med_pill_round_flat_L2_solid_x_01_f.74c0227e.png";